import React, { useState, useContext, useEffect, useRef } from 'react';
import classNames from 'classnames';
import './Engine.scss';
import VideoSimple from '@/v2/components/media/video/VideoSimple';
import TimelineText from '@/v2/components/atoms/TimelineText';
import TextBottom from '@/v2/components/atoms/TextBottom';
import Slider from '@/v2/components/atoms/Slider';
import SwipeUp from '@/v2/components/atoms/Icon/SwipeUp';
import Header from '@/v2/components/application/Header';
import { IsIOSSafari } from '@/v2/components/utils/DeviceUtils';
import Disclaimer from '@/v2/components/layouts/Disclaimer';
import { PerformanceContext } from '@/v2/state/providers';
import { MomentStateContext } from '@/v2/state/momentState';
import { timeout, clearTimeouts } from '@/v2/components/utils/Timeout';

let activated = false;
let videoController = null;

const isBrowserIOSSafari = IsIOSSafari();

const videoReady = (controller, onReady, setTime) => {
    videoController = controller;
    videoController.AddOnTimeUpdated(() => {
        setTime(videoController.GetTime());
    });

    onReady();
};

const play = () => {
    videoController.Play();
};

const activate = () => {
    if (activated) return;
    activated = true;
    play();
};

export default ({ isActive, data, onFinished, onReady }) => {
    const [videoFinished, setVideoFinished] = useState(false);
    const [animate, setAnimateState] = useState(null);
    const [{ disclaimer }] = useContext(PerformanceContext);
    const { dispatch: momentDispatch } = useContext(MomentStateContext);

    const time = useRef(TimelineText.Time());

    const setAnimateOut = () => {
        setAnimateState('out');
        timeout(() => {
            onFinished();
        }, 1000);
    };

    useEffect(() => () => clearTimeouts(), []);

    useEffect(() => {
        if (isActive && videoController) {
            videoController.ProgressDispatch(momentDispatch);
            activate();
        }
    }, [isActive, videoController]);

    const options = {
        bufferBeforePlay: true,
        onReady: (controller) => videoReady(controller, onReady, time.current.Set),
        autoPlay: true,
        onFinished: () => {
            setVideoFinished(true);
            setAnimateState('in');
        },
    };

    const classes = classNames({
        Engine: true,
        'ios-safari': isBrowserIOSSafari,
    });

    const headerContent = <Header show={isActive} animate hideLogo dark />;
    const disclaimerContent = isActive && disclaimer ? <Disclaimer data={disclaimer} dark /> : '';

    return (
        <div className={classes}>
            <VideoSimple src={data.video} options={options} />
            {headerContent}
            <TimelineText data={data.text.timeline} time={time.current} background="dark" color="black" />
            {videoFinished && (
                <div className="Engine__slider-container">
                    <div className="Engine__Slider">
                        <Slider animate={animate} dark isVertical callback={setAnimateOut} customRange={80} />
                    </div>
                    <TextBottom background="dark" animate={animate} color="black" component="h4">
                        <div>
                            {data.text.cta.proceed}
                            <i className="icon">
                                <SwipeUp />
                            </i>
                        </div>
                    </TextBottom>
                </div>
            )}
            {disclaimerContent}
        </div>
    );
};
